module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "Project to obtain the prices of the most important cryptocurrencies through the Coincap REST API.": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proyecto para obtener las cotizaciones de las cryptomonedas mas importantes a traves de la API REST de Coincap."])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"es":{"Project to obtain the prices of the most important cryptocurrencies through the Coincap REST API.":"Proyecto para obtener las cotizaciones de las cryptomonedas mas importantes a traves de la API REST de Coincap."}}')
  delete Component.options._Ctor
  
}
